module.exports = __webpack_public_path__ + "img/c100.d922fba0.jpg";